import React, { useState, useEffect } from 'react'
import AdminTop from '../AdminTop'
import AdminNav from '../AdminNav'
import AdminFooter from '../AdminFooter'
import '../../../css/AdminHome.css'
import { Table } from 'react-bootstrap'
// import { projectList } from '../../../components/ProjectList'
import AddProjects from './AddProjects'
import { useNavigate } from 'react-router-dom'
import EditProjects from './EditProjects'
import DeleteProject from './DeleteProject'
import axios from 'axios'

const Pagination = ({ itemsPerPage, Data }) => {

    const [currentPage, setCurrentPage] = useState(1)

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = Data.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(Data.length / itemsPerPage)

    const handlePageClick = (page) => {
        setCurrentPage(page)
    }

    return (
        <>

            <Table responsive hover bordered>
                <thead>
                    <tr>
                        <th>S.N.</th>
                        <th>PROJECT NAME</th>
                        <th>ADDRESS</th>
                        <th>OPTIONS</th>
                    </tr>
                </thead>
                <tbody>
                    {currentItems.map((item, index) => {
                        return (
                            <tr key={index}>
                                <td>{item.projectID}</td>
                                <td>{item.projectName}</td>
                                <td>
                                    {
                                        item.location === "" ?
                                            <span>N/A</span> : item.location
                                    }
                                </td>
                                <td>
                                    <EditProjects EditProject={item} />
                                    <DeleteProject DelID={item.projectID} DelName={item.projectName} />
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </Table>

            <div className="pagination">
                {Array.from({ length: totalPages }, (_, index) => (
                    <button
                        key={index}
                        onClick={() => handlePageClick(index + 1)}
                        className={currentPage === index + 1 ? 'active' : ''}
                    >
                        {index + 1}
                    </button>
                ))}
            </div>
        </>
    )

}

const ProjectsHome = () => {

    const [auth, setAuth] = useState(false)
    const [projectList, setProjectList] = useState([])

    const fetchProject = () => {
        axios.get(`${process.env.REACT_APP_BASEURL}/projects`)
            .then(res => {
                if (res.data.status === "Success") {
                    setProjectList(res.data.projectDetail)
                }
                else {
                    console.log("Error Getting Data From Backend!!")
                }
            })
    }

    const navigate = useNavigate()
    axios.defaults.withCredentials = true

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_BASEURL}/`)
            .then(res => {
                if (res.data.status === "Success") {
                    // console.log(res.data)
                    setAuth(true)
                }
                else {
                    setAuth(false)
                    alert(res.data.errorMsg)
                    navigate('/login')
                }
            })

        fetchProject()

    }, [navigate])

    return (

        <>

            {auth ? <>
                <div className="header-top">
                    <AdminTop />
                </div>

                <div className="header-navbar">
                    <AdminNav />
                </div>

                <div className="home-content1">
                    <div className="content-top">
                        <div className="content-top-left">
                            <input type="text" placeholder='Search...' className='content-search' />
                            <i className="bi bi-search" />
                        </div>
                        <div className="content-add">
                            {/* <button className="content-add-button">+ Add Project</button> */}
                            <AddProjects />
                        </div>
                    </div>
                    <div className="content-body">
                        <div className="content-body-title">
                            <h3>Project List</h3>
                        </div>
                        <div className="content-body-list">
                            <Pagination itemsPerPage={10} Data={projectList} />
                        </div>
                    </div>
                </div>

                <div className="footer-links">
                    <AdminFooter />
                </div>
            </> : ""}

        </>

    )
}

export default ProjectsHome
